import _ from "lodash";
import React from "react";
import LabelChip from "../Chips/LabelChip";
import { getChipImage } from "../Utils";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./ModulesSection.scss";
import SkeletonLoader from "UIComponents/SkeletonLoader";

const CHIP_COUNT = 6;

const ModulesSection = props => {
  const {
    isData,
    isLoading,
    onSelectModule,
    onUnselectModule,
    data = [],
    selectedModule,
  } = props;

  return (
    <div className={classes.modulesSelectionContainer} role="list">
      <div className={classes.modulesChipContainer}>
        {!isData && isLoading
          ? _.times(CHIP_COUNT, index => {
              return (
                <div key={index} className={classes.skeletonContainer}>
                  <SkeletonLoader
                    variant="rounded"
                    width="100px"
                    height="32px"
                  />
                </div>
              );
            })
          : _.map(data, module => {
              const { id, title, type } = module;

              const currentModuleName = _.join(
                _.slice(_.split(id, "_"), 1),
                "_"
              );
              const isSelected = _.isEqual(currentModuleName, selectedModule);

              const handleOnChipClick = () => {
                if (isSelected) {
                  onUnselectModule();
                  return;
                }
                onSelectModule({ type });
              };

              return (
                <LabelChip
                  key={id}
                  id={id}
                  type={type}
                  icon={getChipImage({ type })}
                  label={title}
                  onClick={handleOnChipClick}
                  isSelected={isSelected}
                />
              );
            })}
      </div>
    </div>
  );
};

export default compose(
  I18nHOC({
    resource: ["common", "teacherHomePage", "integration"],
  })
)(ModulesSection);
